var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('feedback'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"main_wrap"},[_c('div',{staticClass:"mobiSection"},[_c('div',{staticClass:"mobiSection__content"},[_c('div',{staticClass:"mobiForm"},[_c('h2',{staticClass:"mobiTitle sm text_color"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback_intro')))])]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Overall')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating1","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating1},on:{"rating-selected":function($event){_vm.rating1 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('content')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating2","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating2},on:{"rating-selected":function($event){_vm.rating2 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm"},[_c('label',[_vm._v(_vm._s(_vm.$t('Usability')))]),_vm._v(" "),_c('div',{staticClass:"mobiForElm__wrap"},[_c('star-rating',{attrs:{"id":"rating3","inline":true,"star-size":24,"increment":0.01,"active-color":"#ffb902","show-rating":false,"border-width":2,"border-color":"#feb801","rounded-corners":false,"inactive-color":"transparent","star-points":[
                              23,
                              2,
                              14,
                              17,
                              0,
                              19,
                              10,
                              34,
                              7,
                              50,
                              23,
                              43,
                              38,
                              50,
                              36,
                              34,
                              46,
                              19,
                              31,
                              17
                            ],"rating":_vm.rating3},on:{"rating-selected":function($event){_vm.rating3 = $event}}})],1)]),_vm._v(" "),_c('div',{staticClass:"mobiForElm lg"},[_c('label',[_vm._v(_vm._s(_vm.$t('Your Suggestion')))]),_vm._v(" "),_c('textarea',{attrs:{"rows":"4","cols":"50","placeholder":_vm.$t('feedback_comment')}})])]),_vm._v(" "),_c('div',{staticClass:"btnContainer"},[_c('button',{staticClass:"mobiBtn",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("submit")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62493993","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funplus/Feedback.vue
// module id = 1918
// module chunks = 0